import { render, staticRenderFns } from "./Denounce-pagination.vue?vue&type=template&id=a361f5f0"
import script from "./Denounce-pagination.vue?vue&type=script&lang=js"
export * from "./Denounce-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports